import React from 'react'
import "./photo.css"
import {
    Card,
    Table,
    Stack,
    Paper,
    Avatar,
    Button,
    Container,
    Typography,
    IconButton,
    TableContainer,
    TablePagination,
    // ListItemIcon,
    Box,
    TextField,
    Tooltip,

} from '@mui/material';
import { useNavigate } from "react-router-dom"

import { styled } from '@mui/material/styles';
import ListItemIcon from '@mui/material/ListItemIcon';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { apiUrl } from '../../utils/api';

const DataLogo = ({ name, path, }) => {
    const url = `${apiUrl.shopPhoto}${path}`;
    console.log("photosURL", url)
    return (
        <img className="card" alt={name} src={url} style={{ height: "90%", width: "90%" }}
        />

    )
}

const SallerHeader = ({ seller }) => {

    console.log("ShopImg", seller?.photo_1)
    const navigate = useNavigate();
    return (
        <>
            <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                <Button onClick={() => navigate("/dashboard/seller")}>
                    <ListItemIcon >
                        <ArrowBackIcon style={{ color: "blue" }} />
                    </ListItemIcon>
                </Button>
                <Box  >
                    <DataLogo path={seller?.photo_1} />
                </Box>
                <Box  >
                    <DataLogo path={seller?.photo_2} />
                </Box>
                <Box  >
                    <DataLogo path={seller?.photo_3} />
                </Box>

            </Stack>
        </>
    )
}

export default SallerHeader
